export default "/images/check-icon-blue.png?15be36ca96d8b1e15e915e0da14bc185";